import React, { useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/solid';
import { TOAST_TYPES } from '../contexts/ToastContext';

const toastIcons = {
  [TOAST_TYPES.SUCCESS]: CheckCircleIcon,
  [TOAST_TYPES.ERROR]: XCircleIcon,
  [TOAST_TYPES.WARNING]: ExclamationTriangleIcon,
  [TOAST_TYPES.INFO]: InformationCircleIcon,
};

const toastColors = {
  [TOAST_TYPES.SUCCESS]: 'bg-green-50 text-green-800 border-green-200',
  [TOAST_TYPES.ERROR]: 'bg-red-50 text-red-800 border-red-200',
  [TOAST_TYPES.WARNING]: 'bg-yellow-50 text-yellow-800 border-yellow-200',
  [TOAST_TYPES.INFO]: 'bg-blue-50 text-blue-800 border-blue-200',
};

const Toast = ({ toast, onRemove }) => {
  const { id, message, type, duration } = toast;
  const Icon = toastIcons[type];
  const colorClass = toastColors[type];

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onRemove(id);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [id, duration, onRemove]);

  return (
    <div className={`
      flex items-center p-4 mb-4 border rounded-lg shadow-sm
      ${colorClass}
      animate-in slide-in-from-right duration-300
    `}>
      <Icon className="flex-shrink-0 w-5 h-5 mr-3" />
      <div className="flex-1 text-sm font-medium">
        {message}
      </div>
      <button
        onClick={() => onRemove(id)}
        className="flex-shrink-0 ml-3 text-gray-400 hover:text-gray-600 transition-colors"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Toast;